export * from "./floating-images";
